var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 18,
    height: 18,
    transform: "translate(344.594 403.59)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Terms_and_policies_Icon_White_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Terms_and_policies_Icon_White_2",
    "data-name": "Terms and policies Icon White \\u2013 2",
    clipPath: "url(#clip-Terms_and_policies_Icon_White_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3880",
    "data-name": "Group 3880",
    transform: "translate(-344.594 -403.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3879",
    "data-name": "Group 3879",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6254",
    "data-name": "Path 6254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3872",
    "data-name": "Group 3872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6310",
    "data-name": "Path 6310",
    d: "M354.035,421.1l-.113-.033c-8.837-2.613-7.524-14.665-7.51-14.786l.023-.192.166-.1a14.465,14.465,0,0,1,14.868,0l.166.1.022.192c.014.121,1.327,12.175-7.509,14.786Zm-6.846-14.533c-.124,1.5-.636,11.386,6.846,13.7,7.489-2.313,6.97-12.193,6.846-13.7A13.643,13.643,0,0,0,347.189,406.562Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_675",
    "data-name": "Line 675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3873",
    "data-name": "Group 3873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6311",
    "data-name": "Path 6311",
    d: "M354.035,420.979a.3.3,0,0,1-.3-.3V417.81a.3.3,0,0,1,.6,0v2.869A.3.3,0,0,1,354.035,420.979Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6255",
    "data-name": "Path 6255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3874",
    "data-name": "Group 3874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6312",
    "data-name": "Path 6312",
    d: "M357.943,410.694a.4.4,0,0,1-.194-.05l-3.714-2.06-3.714,2.06a.4.4,0,1,1-.388-.7l3.908-2.167a.4.4,0,0,1,.388,0l3.909,2.167a.4.4,0,0,1-.2.75Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6256",
    "data-name": "Path 6256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3875",
    "data-name": "Group 3875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6313",
    "data-name": "Path 6313",
    d: "M357.568,414.564H350.5v-4.7h.8v3.9h5.464v-3.9h.8Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6257",
    "data-name": "Path 6257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3876",
    "data-name": "Group 3876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6314",
    "data-name": "Path 6314",
    d: "M354.028,414.167h-.8V411.5a.556.556,0,0,0-1.112,0v2.669h-.8V411.5a1.357,1.357,0,0,1,2.713,0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6258",
    "data-name": "Path 6258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3877",
    "data-name": "Group 3877"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6315",
    "data-name": "Path 6315",
    d: "M356.757,414.167h-.8V411.5a.555.555,0,1,0-1.111,0v2.669h-.8V411.5a1.356,1.356,0,0,1,2.713,0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6259",
    "data-name": "Path 6259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3878",
    "data-name": "Group 3878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6316",
    "data-name": "Path 6316",
    d: "M358.344,416.045h-8.617v-.552a.985.985,0,0,1,.984-.984h6.648a.985.985,0,0,1,.985.984Z",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnc);
export default __webpack_public_path__ + "static/media/tnc.b81ed603605f4d589117caecb228153f.svg";
export { ForwardRef as ReactComponent };